import { Stack } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import Comment from "./Comment";
import { CommentFields } from "../types/comment.types";
import { RequestBaseFields } from "../types/request.types";
import { requestResourceUrl } from "../lib/mts-url";

interface CommentsProps {
  request: RequestBaseFields;
}

export default function Comments({ request }: CommentsProps) {
  const commentsPath = requestResourceUrl(request, 'comments');
  const query = useQuery({
    queryKey: [commentsPath],
    queryFn: () => fetch(commentsPath).then(r => r.json())
  });
  let content;

  if (query.isPending) {
    content = 'Loading...';
  } else if (query.isSuccess) {
    const { data } = query;

    content = (
      <Stack>
        {data.map((c: CommentFields) => <Comment key={c.id} comment={c} />)}
      </Stack>
    );
  }
  
  return (
    <div>
      {content}
    </div>
  );
}
